"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../index");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _DialogHandler = _interopRequireDefault(require("../../handlers/DialogHandler"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _OverlayHandler = _interopRequireDefault(require("../../handlers/OverlayHandler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dialog = /*#__PURE__*/function (_Component) {
  function Dialog(props) {
    var _this;
    _classCallCheck(this, Dialog);
    _this = _callSuper(this, Dialog, [props]);
    _defineProperty(_this, "hideTimer", null);
    _defineProperty(_this, "dialogDefinition", null);
    _this.secondaryBtnRef = /*#__PURE__*/_react["default"].createRef();
    _this.primaryBtnRef = /*#__PURE__*/_react["default"].createRef();
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.setNewState = _this.setNewState.bind(_this);
    _this.setStateFromProps = _this.setStateFromProps.bind(_this);
    _this.isShowing = _this.isShowing.bind(_this);
    _this.startAnimation = _this.startAnimation.bind(_this);
    _this.stopAnimation = _this.stopAnimation.bind(_this);
    _this.resetAnimation = _this.resetAnimation.bind(_this);
    _this.getUpdatedPosition = _this.getUpdatedPosition.bind(_this);
    _this.dialogDefinition = _this.setStateFromProps(props);
    _this.state = _this.setStateFromProps(props);
    return _this;
  }
  _inherits(Dialog, _Component);
  return _createClass(Dialog, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (!prevState.display && this.state.display) {
        this.getUpdatedPosition();
      }
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      if (this.state.primaryBtnText && !this.state.managedByContent) this.primaryBtnRef.current.startAnimation();
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      if (this.state.primaryBtnText && !this.state.managedByContent) this.primaryBtnRef.current.stopAnimation();
    }
  }, {
    key: "resetAnimation",
    value: function resetAnimation() {
      if (this.state.primaryBtnText && !this.state.managedByContent) this.primaryBtnRef.current.reset();
    }
  }, {
    key: "show",
    value: function show() {
      var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      setTimeout(function () {
        newState = self.setStateFromProps(newState);
        self.setState(_objectSpread(_objectSpread({}, newState), {}, {
          display: true
        }));
        if (!(newState.primaryBtnText || newState.secondaryBtnText) && !newState.managedByContent) {
          clearTimeout(self.hideTimer);
          self.hideTimer = setTimeout(function () {
            _DialogHandler["default"].hide();
          }, newState.hideAfter || self.state.hideAfter);
        }
      }, self.state.showAfter);
    }
  }, {
    key: "hide",
    value: function hide() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      this.setState({
        display: false
      });
      callback();
    }
  }, {
    key: "setNewState",
    value: function setNewState(state) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.setState(this.setStateFromProps(state), function () {
        callback();
      });
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.state.display;
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps(props) {
      var _this$state;
      var nextProps = props || {};
      var definition = this.dialogDefinition || {};
      var newState = {
        display: this.props.display || ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.display) || false,
        type: nextProps.type || definition.type || "default",
        className: nextProps.className || definition.className || "",
        title: nextProps.title || definition.title || null,
        content: nextProps.content || definition.content || null,
        primaryBtnText: nextProps.primaryBtnText || definition.primaryBtnText || null,
        primaryBtnOnClick: nextProps.primaryBtnOnClick || definition.primaryBtnOnClick || null,
        secondaryBtnText: nextProps.secondaryBtnText || definition.secondaryBtnText || null,
        secondaryBtnOnClick: nextProps.secondaryBtnOnClick || definition.secondaryBtnOnClick || null,
        hideAfter: nextProps.hideAfter || definition.hideAfter || 2500,
        showAfter: nextProps.showAfter || definition.showAfter || 0,
        managedByContent: nextProps.managedByContent || definition.managedByContent || false,
        adjustedPosition: this.getUpdatedPosition(true)
      };
      if (newState.primaryBtnText || newState.secondaryBtnText) {
        clearTimeout(this.hideTimer);
      }
      return newState;
    }
  }, {
    key: "getUpdatedPosition",
    value: function getUpdatedPosition() {
      var returnValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var position = {};
      var overlayRect = document.querySelector(".overlay-component.show .overlayContentContainer");
      var dialogRect = document.querySelector(".dialog-component .dialogContentContainer");
      if (!overlayRect || !dialogRect) {
        position = {};
      } else {
        overlayRect = overlayRect.getBoundingClientRect();
        dialogRect = dialogRect.getBoundingClientRect();
        position = {
          position: "absolute",
          top: overlayRect.y + overlayRect.height - dialogRect.height - 24 + "px",
          left: overlayRect.x + overlayRect.width - dialogRect.width - 24 + "px"
        };
      }
      if (returnValue) {
        return position;
      } else {
        this.setState({
          adjustedPosition: position
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var hasBtn = this.state.primaryBtnText || this.state.secondaryBtnText || this.state.managedByContent;
      var classes = (0, _classnames["default"])("dialog-component", this.state.className, this.state.type, {
        "show": this.state.display,
        "hasBtn": hasBtn,
        "overlayOpened": _OverlayHandler["default"].isShowing()
      });
      var leadOrder = [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.state.type !== "default" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.state.type === "success" ? /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: "glyph-heavy-success"
      }) : /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: "glyph-heavy-warning"
      }))), this.state.title];
      if (!hasBtn) {
        leadOrder.reverse();
      }
      var leadClasses = (0, _classnames["default"])(this.state.type, {
        "hasBtnRow": hasBtn,
        "lead": hasBtn
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "dialog-component",
        className: classes
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "dialogOverlay"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dialogContentContainer",
        style: this.state.adjustedPosition
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "titleContent"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: leadClasses
      }, leadOrder[0], leadOrder[1])), this.state.content && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dialogContent"
      }, this.state.content), hasBtn && this.state.managedByContent === false && /*#__PURE__*/_react["default"].createElement("div", {
        className: "dialogBtns"
      }, this.state.secondaryBtnText && /*#__PURE__*/_react["default"].createElement(_index.Button, {
        ref: this.secondaryBtnRef,
        shapeStyle: "stroke",
        colorTheme: "grey",
        size: "small",
        radius: "square",
        text: this.state.secondaryBtnText,
        onClick: function onClick() {
          if (_this2.state.secondaryBtnOnClick) {
            _this2.state.secondaryBtnOnClick(_this2.secondaryBtnRef);
          } else {
            _DialogHandler["default"].hide();
          }
        }
      }), this.state.primaryBtnText && /*#__PURE__*/_react["default"].createElement(_index.Button, {
        ref: this.primaryBtnRef,
        shapeStyle: "fill",
        colorTheme: "teal",
        size: "small",
        radius: "square",
        animated: true,
        animateOnClick: false,
        text: this.state.primaryBtnText,
        onClick: function onClick() {
          if (_this2.state.primaryBtnOnClick) {
            _this2.state.primaryBtnOnClick(_this2.primaryBtnRef);
          } else {
            _DialogHandler["default"].hide();
          }
        }
      }))));
    }
  }]);
}(_react.Component);
;
Dialog.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  primaryBtnText: _propTypes["default"].string,
  primaryBtnOnClick: _propTypes["default"].func,
  secondaryBtnText: _propTypes["default"].string,
  secondaryBtnOnClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["default", "success", 'warning', "error"]),
  hideAfter: _propTypes["default"].number,
  showAfter: _propTypes["default"].number,
  managedByContent: _propTypes["default"].bool
};
Dialog.defaultProps = {};
var _default = exports["default"] = Dialog;